export default __webpack_public_path__ + "static/media/detourage_moi_02_mobile.cae195ee.png";